import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class DemandeService {
	constructor(private http: HttpClient) { }

	new(type: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:new',
			params: {
				type: type,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:get',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(type: string, parameters: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:set',
			params: {
				type: type,
				parameters: parameters,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	print(id: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:print',
			params: {
				id: id,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	courrier(code: any, ids: any, options: any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:courrier',
			params: {
				code: code,
				ids: ids,
				options: options,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	setChampsValeurs(
		idDemande: number,
		champValeurs: any = []
	): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:setChampsValeurs',
			params: {
				idDemande: idDemande,
				champValeurs: champValeurs,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}

    getActionList(options:any = []): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.demande:getActionList',
			params: {
	                options:options
	            }
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
